import { render, staticRenderFns } from "./ListArticleTitle.vue?vue&type=template&id=7af23789&"
import script from "./ListArticleTitle.vue?vue&type=script&lang=js&"
export * from "./ListArticleTitle.vue?vue&type=script&lang=js&"
import style0 from "./ListArticleTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports